<template>
    <div :class="classes">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'CoreBorderWrapper',

    props: {
        noBorder: {
            type: Boolean,
            default: false,
        },

        condensed: {
            type: Boolean,
            default: false,
        },

        autoHeight: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        classes() {
            return {
                'core-border-wrapper': true,
                'core-border-wrapper--no-border': this.noBorder,
                'core-border-wrapper--condensed': this.condensed,
                'core-border-wrapper--auto-height': this.autoHeight,
            }
        },
    },
}
</script>

<style scoped>
.core-border-wrapper {
    height: 5.1rem;
    border: 1px solid var(--color-neutral-medium);
    border-radius: 8px;

    padding: 0 16px;

    display: flex;
    align-items: center;

    &.core-border-wrapper--no-border {
        border-color: transparent;
    }

    &.core-border-wrapper--condensed {
        height: 50px;
    }

    &.core-border-wrapper--auto-height {
        height: auto;
        min-height: 5.1rem;
        padding-top: 8px;
        padding-bottom: 8px;
    }

    &.core-border-wrapper--condensed.core-border-wrapper--auto-height {
        min-height: 50px;
    }
}
</style>
